<template>
  <div
    class="status-tag-container"
    :class="overviewStatusArr[status]"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'StatusTag',
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      overviewStatusArr: ['', 'payed', 'not-payed', 'no-bill', 'billed', 'not-bill'],
    };
  },
};
</script>
<style lang="scss" scoped>
  .status-tag-container{
    &::after {
      display: inline-flex;
      padding: 0 10px;
      height: 36px;
      justify-content: center;
      align-items: center;
      vertical-align: middle;
      border-radius: 6px;
      background: #FFF5F4;
      font-size: 20px;
      font-weight: bold;
      color: #DD3429;
    }
    &.payed::after {
      content: '已打款';
      background-color: #EFFCF2;
      color: #009659;
    }
    &.not-payed::after {
      content: '未打款';
    }
    &.no-bill::after {
      content: '未出账单';
      min-width: 35px;
    }
    &.billed::after {
      content: '已出账单';
      background-color: #EFFCF2;
      color: #009659;
    }
    &.not-bill::after {
      content: '无账单';
    }
  }
</style>
